import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { latLng, tileLayer, icon, marker, control } from 'leaflet';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import * as i3 from '@asymmetrik/ngx-leaflet';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

/* eslint-disable @angular-eslint/component-selector */
class MapComponent {
    lat;
    long;
    height;
    mobile = false;
    options;
    layers;
    initialized = false;
    faulty = false;
    loading = false;
    map;
    ngAfterViewInit() {
        setTimeout(() => {
            this.initializeMap();
            this.loading = false;
        }, 10);
    }
    ngOnChanges(changes) {
        if ((changes['lat']?.currentValue && !changes['lat']?.isFirstChange()) ||
            (changes['long']?.currentValue && !changes['long']?.isFirstChange())) {
            this.initializeMap();
            this.map?.setView(latLng(changes['lat'].currentValue, changes['long'].currentValue));
        }
    }
    initializeMap() {
        if (this.lat && this.long) {
            this.options = {
                layers: [
                    tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 18,
                        attribution: 'BEEGO',
                    }),
                ],
                center: latLng(this.lat, this.long),
                zoom: 12,
                zoomControl: !this.mobile,
            };
            this.layers = [
                marker(latLng(this.lat, this.long), {
                    icon: icon({
                        iconSize: [40, 40],
                        iconAnchor: [13, 41],
                        iconUrl: './assets/imgs/marker.png',
                    }),
                }),
            ];
            this.initialized = true;
            this.faulty = false;
        }
        else
            this.faulty = true;
    }
    onMapLoad(map) {
        this.map = map;
        if (this.mobile) {
            map.addControl(control.zoom({ position: 'topright' }));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MapComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: MapComponent, selector: "map-component", inputs: { lat: "lat", long: "long", height: "height", mobile: "mobile" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"_map-component\" [style.height.px]=\"height\">\n\t<div *ngIf=\"loading; else notLoading\" class=\"_loading\">\n\t\t<ion-spinner name=\"circles\"></ion-spinner>\n\t</div>\n\t<ng-template #notLoading> \n\t\t<ng-container *ngIf=\"initialized && !faulty; else noMap\">\n\t\t\t<div class=\"_map\" [style.height.px]=\"height\" leaflet [leafletOptions]=\"options\" [leafletLayers]=\"layers\" (leafletMapReady)=\"onMapLoad($event)\"></div>\n\t\t</ng-container>\n\t\t<ng-template #noMap>\n\t\t\t<div class=\"_faulty\">\n\t\t\t\t<p [translate]=\"'MAP_NOT_LOADING'\"></p>\n\t\t\t</div>\n\t\t</ng-template>\n\t</ng-template>\n</div>", styles: ["._map-component ._loading{display:flex;flex-direction:row;align-items:center;justify-content:center;height:100%}._map-component ._map{width:100%}._map-component ._faulty{height:100%;width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.IonSpinner, selector: "ion-spinner", inputs: ["color", "duration", "name", "paused"] }, { kind: "directive", type: i3.LeafletDirective, selector: "[leaflet]", inputs: ["leafletFitBoundsOptions", "leafletPanOptions", "leafletZoomOptions", "leafletZoomPanOptions", "leafletOptions", "leafletZoom", "leafletCenter", "leafletFitBounds", "leafletMaxBounds", "leafletMinZoom", "leafletMaxZoom"], outputs: ["leafletMapReady", "leafletZoomChange", "leafletCenterChange", "leafletClick", "leafletDoubleClick", "leafletMouseDown", "leafletMouseUp", "leafletMouseMove", "leafletMouseOver", "leafletMouseOut", "leafletMapMove", "leafletMapMoveStart", "leafletMapMoveEnd", "leafletMapZoom", "leafletMapZoomStart", "leafletMapZoomEnd"] }, { kind: "directive", type: i3.LeafletLayersDirective, selector: "[leafletLayers]", inputs: ["leafletLayers"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'map-component', template: "<div class=\"_map-component\" [style.height.px]=\"height\">\n\t<div *ngIf=\"loading; else notLoading\" class=\"_loading\">\n\t\t<ion-spinner name=\"circles\"></ion-spinner>\n\t</div>\n\t<ng-template #notLoading> \n\t\t<ng-container *ngIf=\"initialized && !faulty; else noMap\">\n\t\t\t<div class=\"_map\" [style.height.px]=\"height\" leaflet [leafletOptions]=\"options\" [leafletLayers]=\"layers\" (leafletMapReady)=\"onMapLoad($event)\"></div>\n\t\t</ng-container>\n\t\t<ng-template #noMap>\n\t\t\t<div class=\"_faulty\">\n\t\t\t\t<p [translate]=\"'MAP_NOT_LOADING'\"></p>\n\t\t\t</div>\n\t\t</ng-template>\n\t</ng-template>\n</div>", styles: ["._map-component ._loading{display:flex;flex-direction:row;align-items:center;justify-content:center;height:100%}._map-component ._map{width:100%}._map-component ._faulty{height:100%;width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center}\n"] }]
        }], propDecorators: { lat: [{
                type: Input
            }], long: [{
                type: Input
            }], height: [{
                type: Input
            }], mobile: [{
                type: Input
            }] } });

class MapModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.7", ngImport: i0, type: MapModule, declarations: [MapComponent], imports: [CommonModule, IonicModule, LeafletModule], exports: [MapComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MapModule, imports: [CommonModule, IonicModule, LeafletModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MapModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapComponent],
                    exports: [MapComponent],
                    imports: [CommonModule, IonicModule, LeafletModule],
                    providers: [],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/*
 * Public API Surface of ngx-map
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MapComponent, MapModule };
